"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Get the browser language in a two character format, e.g. 'nb' or 'en'
// https://zzz.buzz/2016/01/13/detect-browser-language-in-javascript/
function getDefaultBrowserLocale() {
    // IE has a non-standard attribute userLanguage. So we will extend
    // the type to avoid a flow error when we check this property
    const navigator = window.navigator;
    const language = (navigator.languages && navigator.languages[0]) || navigator.language;
    return language.split("-")[0];
}
exports.default = getDefaultBrowserLocale;
